import React from 'react'
import Link from 'next/link'

import { Separator, buttonVariants } from '@hanzo/ui/primitives'
import { Box, cn, css } from '@hanzo/ui'
// `link` was a SIZE in the 5.x line and is a variant here; a radius is a class.
const linkClx = cn(buttonVariants({ variant: 'linkMuted' }), 'rounded-none')

const PolicyLinks: React.FC<{
  clx?: string
}> = ({
  clx=''
}) => (
  <Box className={cn('flex flex-col items-center', clx)}>
    <Separator/>
    <Box className='flex gap-4 py-2 text-sm'>
      {/* TODO: add Refund policy and Privacy policy links */}
      <Link style={css(linkClx)} href=''>refund policy</Link>
      <Link style={css(linkClx)} href=''>privacy policy</Link>
    </Box>
  </Box>   
)

export default PolicyLinks
